import React from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';

export type DateFilterType = 'today' | 'month' | 'custom';

interface DashboardDateFilterProps {
  filter: DateFilterType;
  setFilter: (filter: DateFilterType) => void;
  startDate: string;
  setStartDate: (date: string) => void;
  endDate: string;
  setEndDate: (date: string) => void;
  onApply: () => void;
}

export const DashboardDateFilter: React.FC<DashboardDateFilterProps> = ({
  filter,
  setFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onApply,
}) => {
  return (
    <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex flex-col md:flex-row items-center gap-4 mb-6">
      <div className="flex items-center gap-2 text-gray-700 font-medium">
        <CalendarIcon className="w-5 h-5 text-indigo-600" />
        <span>Filter Waktu:</span>
      </div>
      
      <div className="flex-1 flex flex-col sm:flex-row items-center gap-3 w-full">
        <select
          value={filter}
          onChange={(e) => {
            setFilter(e.target.value as DateFilterType);
            if (e.target.value !== 'custom') {
              onApply();
            }
          }}
          className="appearance-none bg-gray-50 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-indigo-500 w-full sm:w-48"
        >
          <option value="today">Hari Ini</option>
          <option value="month">Bulan Ini</option>
          <option value="custom">Pilih Tanggal Kustom</option>
        </select>

        {filter === 'custom' && (
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="bg-gray-50 border border-gray-200 text-gray-700 py-2 px-3 rounded-lg focus:outline-none focus:border-indigo-500 w-full sm:w-auto"
            />
            <span className="text-gray-500">-</span>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="bg-gray-50 border border-gray-200 text-gray-700 py-2 px-3 rounded-lg focus:outline-none focus:border-indigo-500 w-full sm:w-auto"
            />
            <button
              onClick={onApply}
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg transition-colors whitespace-nowrap"
            >
              Terapkan
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
